import styled from 'styled-components';

type Props = {
  maxLines?: number;
};

export const Truncated = styled.div<Props>`
  /* stylelint-disable */
  /* Restrict the box to the specified number of lines of text.
   * See https://css-tricks.com/almanac/properties/l/line-clamp/ */
  display: -webkit-box;
  -webkit-line-clamp: ${props => props.maxLines ?? 2};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
